import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../config/axios";
import { WheelRotateResultIFace } from "../types/wheel-popup.type";
import WinnerScreen from "./WinnerScreen";
import { handleApiError } from "../utils/handleApiError";
import useLayoutStore from "../store/layout.store";

// انیمیشن‌ها
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.25, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 80, damping: 14 },
  },
};

const WheelScreen = () => {
  const wheelRef = useRef<HTMLImageElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const [wheelDetails, setWheelDetails] = useState<any>(null);

  const [winnerData, setWinnerData] = useState<any>(null);

  const setShowLogoInHeader = useLayoutStore((state) => state.setShowLogoInHeader);

  const handleFetchWheelDetails = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get("v1/fortune/wheel/");
      setWheelDetails(response?.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFetchWheelResult = async () => {
    if (isLoading) return;
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(
        `v1/fortune/wheel/${wheelDetails?.id}/rotate/`
      );
      const result = data as WheelRotateResultIFace;
      handleRotation(result);
    } catch {
      toast.error("مشکلی پیش اومده. دوباره امتحان کنید.");
      setIsLoading(false);
    }
  };

  // چرخش گردونه
  const handleRotation = (response: any) => {
    const { rotate_times, wheel_items_number } = response;
    const order = response?.win_item?.order;

    if (wheelRef.current) {
      wheelRef.current.style.transition =
        "transform 3s cubic-bezier(0.46, 0.03, 0.52, 0.96)";
      wheelRef.current.style.transform = `rotate(${
        rotate_times * 360 - order * (360 / wheel_items_number)
      }deg)`;

      // بعد از پایان چرخش → نمایش برنده
      setTimeout(() => {
        setIsLoading(false);
        setWinnerData(response); // 👈 نمایش WinnerScreen
        setShowLogoInHeader(false);
      }, 3200);
    }
  };

  useEffect(() => {
    handleFetchWheelDetails();
  }, []);

  return (
    <div className="w-full h-full min-h-screen flex items-center justify-center relative">
      <motion.div
        className="w-full flex flex-col items-center justify-center"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1
          variants={itemVariants}
          className="text-xl md:text-2xl font-bold text-center mb-6 leading-relaxed text-white"
        >
          گردونه رو بچرخون <br />و شانست رو امتحان کن
        </motion.h1>

        <motion.div
          variants={itemVariants}
          className="relative w-full max-w-[360px] sm:max-w-[420px] md:max-w-[460px]"
        >
          <img
            alt="Wheel Frame"
            src="/images/wheel-bg.webp"
            className="w-full h-auto object-contain"
          />

          <div className="absolute top-[4%] left-1/2 -translate-x-1/2 size-[64%] aspect-square z-[-1]">
            {/* <div className="absolute top-[6%] left-1/2 -translate-x-1/2 w-[83%] aspect-square z-[-1]"> */}
            <img
              alt="wheel"
              ref={wheelRef}
              src={wheelDetails?.image}
              // src="/images/wheel-cover.webp"
              className="w-full h-full object-contain"
            />
          </div>

          <div className="absolute bottom-[8%] left-1/2 -translate-x-1/2">
            <motion.button
              disabled={isLoading}
              onClick={handleFetchWheelResult}
              className="bg-[#f54f02] text-white px-8 py-3 rounded-xl text-lg font-bold shadow-lg hover:bg-orange-600 transition"
            >
              بچرخون
            </motion.button>
          </div>
        </motion.div>
      </motion.div>

      {winnerData && (
        <div className="absolute inset-0 z-50">
          <WinnerScreen
            title={winnerData?.win_item?.title}
            prizeText={winnerData?.win_item?.description}
            amount={winnerData?.win_item?.amount}
          />
        </div>
      )}
    </div>
  );
};

export default WheelScreen;
